export var DECAGON_SCRIPT_URL = "https://decagon.ai/loaders/faire.js";